module.exports = __webpack_public_path__ + "static/img/10areaB_04.2f3f7a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_04.png
// module id = 1083
// module chunks = 1